import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const PrinterIcon = ({
  color = 'foraBlue',
  width = 15,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 11">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M10.608 8.626c.427 0 .775.348.775.774 0 .428-.348.776-.775.776H3.901c-.427 0-.775-.348-.775-.776 0-.426.348-.774.775-.774zm1.87-4.845c.992 0 1.809.77 1.884 1.743l.006.147V8.65c0 .584-.444 1.066-1.011 1.127l-.124.007h-1.149c.033-.123.055-.25.055-.382 0-.798-.612-1.455-1.392-1.525l-.14-.006H3.9c-.843 0-1.53.686-1.53 1.531 0 .088.01.174.026.257l.028.125h-1.29c-.583 0-1.066-.443-1.127-1.01L0 8.648V5.67c0-.992.769-1.809 1.743-1.884l.147-.006h10.587zm-1.43 1.657c-.37 0-.671.3-.671.672 0 .37.3.672.672.672.37 0 .672-.301.672-.672 0-.371-.301-.672-.672-.672zM9.453 0c.626 0 1.135.509 1.135 1.134v2.172H3.78V1.134C3.781.51 4.29 0 4.915 0h4.537z"
      />
    </svg>
  </DefaultIconWrapper>
);
